import {
  GET_BACKER,
  GET_BACKER_SUCCESS,
  GET_BACKER_FAILED,
  GET_GOOGLE_CONVERSIONS,
  GET_GOOGLE_CONVERSIONS_SUCCESS,
  GET_GOOGLE_CONVERSIONS_FAILED,
  GET_META_CONVERSIONS,
  GET_META_CONVERSIONS_SUCCESS,
  GET_META_CONVERSIONS_FAILED,
  GET_PROJECT_VIA_CODE,
  GET_PROJECT_VIA_CODE_SUCCESS,
  GET_PROJECT_VIA_CODE_FAILED,
  UPDATE_PIXEL_FIRED,
  UPDATE_PIXEL_FIRED_SUCCESS,
  UPDATE_PIXEL_FIRED_FAILED,
  GET_REDDIT_CONVERSIONS,
  GET_REDDIT_CONVERSIONS_SUCCESS,
  GET_REDDIT_CONVERSIONS_FAILED,
} from "./consts"

export const getBacker = id => ({
  type: GET_BACKER,
  payload: { id },
})

export const getBackerSuccess = data => ({
  type: GET_BACKER_SUCCESS,
  payload: { data },
})

export const getBackerFailed = error => ({
  type: GET_BACKER_FAILED,
  payload: { error },
})

export const getConversions = id => ({
  type: GET_GOOGLE_CONVERSIONS,
  payload: { id },
})

export const getConversionsSuccess = (id, data) => ({
  type: GET_GOOGLE_CONVERSIONS_SUCCESS,
  payload: { id, data },
})

export const getConversionsFailed = error => ({
  type: GET_GOOGLE_CONVERSIONS_FAILED,
  payload: { error },
})

export const getMetaConversions = (id, data) => ({
  type: GET_META_CONVERSIONS,
  payload: { id, data },
})

export const getMetaConversionsSuccess = (id, data) => ({
  type: GET_META_CONVERSIONS_SUCCESS,
  payload: { id, data },
})

export const getMetaConversionsFailed = error => ({
  type: GET_META_CONVERSIONS_FAILED,
  payload: { error },
})

export const getRedditConversions = (id, data) => ({
  type: GET_REDDIT_CONVERSIONS,
  payload: { id, data },
})

export const getRedditConversionsSuccess = (id, data) => ({
  type: GET_REDDIT_CONVERSIONS_SUCCESS,
  payload: { id, data },
})

export const getRedditConversionsFailed = error => ({
  type: GET_REDDIT_CONVERSIONS_FAILED,
  payload: { error },
})

export const getProjectViaCode = code => ({
  type: GET_PROJECT_VIA_CODE,
  payload: { code },
})

export const getProjectViaCodeSuccess = data => ({
  type: GET_PROJECT_VIA_CODE_SUCCESS,
  payload: { data },
})

export const getProjectViaCodeFailed = error => ({
  type: GET_PROJECT_VIA_CODE_FAILED,
  payload: { error },
})

export const updatePixelFiredAt = () => ({
  type: UPDATE_PIXEL_FIRED,
})

export const updatePixelFiredAtSuccess = data => ({
  type: UPDATE_PIXEL_FIRED_SUCCESS,
  payload: { data },
})

export const updatePixelFiredAtFailed = error => ({
  type: UPDATE_PIXEL_FIRED_FAILED,
  payload: { error },
})
